export const WIDGET_LOCATION = 'widgetLocation';